import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../api';
import HelpButton from '../components/HelpButton';

export default function HomePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    api.getUnreadCount().then(d => setUnreadCount(d.count)).catch(() => {});
  }, []);

  const items = [
    { emoji: '🎰', label: 'Amigo Invisible', path: '/amigo-invisible', soon: false },
    { emoji: '✉️', label: 'Mi Carta', path: '/mi-carta', soon: false },
    { emoji: '📜', label: 'Cartas familia', path: '/cartas-familia', soon: false },
    { emoji: '📸', label: 'Inspiraciones', path: '/inspiraciones', soon: false },
    { emoji: '💌', label: 'Mensajes', path: '/mensajes', soon: false, badge: unreadCount },
  ];

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <h2 style={styles.greeting}>¡Hola, {user?.display_name}! 🌟</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>¿Qué quieres hacer?</p>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          {user?.is_admin && (
            <button className="btn btn-ghost" onClick={() => navigate('/admin')}>⚙️ Panel Admin</button>
          )}
          <button className="btn btn-ghost" onClick={logout}>Salir</button>
          <HelpButton title="🎄 Cómo funciona la app">
            <p>¡Bienvenido a la app familiar de Reyes Magos! Desde aquí puedes acceder a:</p>
            <p><strong>🎰 Amigo Invisible:</strong> descubre a quién le toca regalar (una vez que el sorteo esté hecho).</p>
            <p><strong>✉️ Mi Carta:</strong> escribe tu carta a los Reyes y añade regalos que te gustaría recibir, con foto si quieres.</p>
            <p><strong>📜 Cartas familia:</strong> mira las cartas de los demás y marca lo que ya hayas comprado, para que nadie repita el mismo regalo.</p>
            <p><strong>📸 Inspiraciones:</strong> sube fotos de cosas que te gusten durante todo el año, para cualquier ocasión.</p>
            <p><strong>💌 Mensajes:</strong> habla en privado con cualquiera, o escribe de forma anónima al amigo invisible de alguien.</p>
          </HelpButton>
        </div>
      </div>

      <div style={styles.grid}>
        {items.map(item => (
          <div
            key={item.label}
            className="card"
            style={{ ...styles.gridItem, opacity: item.soon ? 0.6 : 1, cursor: item.soon ? 'default' : 'pointer' }}
            onClick={() => !item.soon && navigate(item.path)}
          >
            <span style={styles.gridEmoji}>{item.emoji}</span>
            <span style={styles.gridLabel}>{item.label}</span>
            {item.soon && <span style={styles.soon}>Próximamente</span>}
            {item.badge > 0 && <span style={styles.notifBadge}>{item.badge}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  page: { padding: '1.5rem' },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '2rem',
  },
  greeting: {
    fontSize: '1.5rem',
    color: 'var(--gold)',
    fontFamily: 'var(--font-display)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '1rem',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '1.5rem 1rem',
    textAlign: 'center',
    opacity: 0.7,
    position: 'relative',
  },
  gridEmoji: { fontSize: '2rem' },
  gridLabel: { fontWeight: 600, fontSize: '0.9rem' },
  notifBadge: {
    position: 'absolute', top: '0.5rem', right: '0.5rem',
    background: 'var(--red-light)', color: '#fff',
    borderRadius: '999px', minWidth: '22px', height: '22px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '0.72rem', fontWeight: 700,
  },
  soon: {
    fontSize: '0.7rem',
    color: 'var(--gold)',
    background: 'rgba(201,168,76,0.1)',
    padding: '0.15rem 0.5rem',
    borderRadius: '999px',
  },
};
